module.exports = __webpack_public_path__ + "static/media/pin-start.a48fd664.svg";